import { Controller } from "stimulus"

// #1732: een melding in Sales & Leads verdwijnt na een paar seconden vanzelf;
// een foutmelding blijft staan tot de medewerker hem wegklikt.
export default class extends Controller {
  static values = { blijf: Boolean }

  connect() {
    if (!this.blijfValue) this.timer = setTimeout(() => this.sluit(), 6000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  sluit() {
    this.element.remove()
  }
}
